
import { Component, Vue } from 'vue-property-decorator';

import Wrapper from '@/components/layout/Wrapper.vue';
import HeaderNav from '@/components/landing/HeaderNav.vue';
import TeaserSection from '@/components/landing/TeaserSection.vue';
import DescriptionSection from '@/components/landing/DescriptionSection.vue';
import PreviewSection from '@/components/landing/PreviewSection.vue';
import SupportSection from '@/components/landing/SupportSection.vue';
import PageFooter from '@/components/common/PageFooter.vue';

@Component({
  components: {
    HeaderNav,
    Wrapper,
    TeaserSection,
    DescriptionSection,
    PreviewSection,
    SupportSection,
    PageFooter,
  },
})
export default class Page extends Vue {}
